//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils/formatDate'
export default {
  data() {
    return {
      id: '', //订单id
      order: { bdsOrderAddressInvoiceEntities: {} }, //订单信息
      stepActive: 1,
      orderStatusTime: {},
      loading: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getOrderDetail()
  },
  methods: {
    // 获取订单详情
    async getOrderDetail() {
      try {
        this.loading = true
        const res = await this.$http.bdOrder.getOrderDetailById({ id: this.id })
        const order = res.data

        order.createTime = formatDate(
          new Date(order.createTime),
          'yyyy-MM-dd hh:mm:ss'
        )
        this.stepActive = order.statusFlag - 1
        this.order = order
        order.bdsOrderStatusEntitys.forEach((item) => {
          this.orderStatusTime[`uptTime${item.statusFlag}`] = formatDate(
            new Date(item.uptTime),
            'yyyy-MM-dd hh:mm:ss'
          )
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
